import { create } from "zustand";
import { GetConnect, PostConnect } from "../../Core/Connect";
import { useLoaderStore } from "../loader";

const loaderAction = useLoaderStore.getState().loaderAction;

export const useDocumentStore = create((set, get) => ({
  documents: [],
  getDocuments: () => {
    GetConnect("documents", (data) => {
      set({ documents: [...data] });
    });
  },
}));
